/* eslint-disable consistent-return */
import { useQueryParamsAsKeyValuePair } from 'hooks/useQueryParams';
import { flatten, isString } from 'lodash';
import React, { useMemo } from 'react';
import { useHistory } from 'react-router';
import { getNewQueryString } from 'utils';

import { InputComponent } from '../Input';
import { INPUT_TYPE, LABEL_TYPE } from '../Input/types';
import { FilterBarContainerStyled } from './styled';
import { IFilterBarProps } from './types';

// function isMultipleSelectFilter(
//   options: ISingleFilterOptionProps | IMultipleFilterOptionsProps,
// ): options is IMultipleFilterOptionsProps {
//   return (options as IMultipleFilterOptionsProps).main !== undefined;
// }

const FilterBar: React.FC<IFilterBarProps> = ({
  options,
  className,
  onChange,
  name,
  label,
  notSpecifiedValueLabel = 'Not Specified',
  placeholder,
  defaultValue,
  disabled,
  inputSettings,
}) => {
  const history = useHistory();
  const query = useQueryParamsAsKeyValuePair();

  const optionsWithUnspecifiedValue = useMemo(() => {
    if (!notSpecifiedValueLabel) return options;
    if (options.some((o) => o.value === 'notSpecified')) return options;
    return [...options, { value: 'notSpecified', label: notSpecifiedValueLabel }];
  }, [options, query?.[name]]);

  const defaultOnChange = (value: any) => {
    let queryValue = value;
    if (value === 'notSpecified') {
      queryValue = undefined;
    }

    const queryString = getNewQueryString(history.location.search, { [name]: queryValue, page: undefined });
    history.push({ pathname: history.location.pathname, search: queryString });
  };

  const FilterBarComponent = useMemo(() => {
    const filterName = name || '';
    const notSpecifiedValue = notSpecifiedValueLabel ? 'notSpecified' : undefined;
    let selectedValue = query?.[name] === undefined ? defaultValue : query?.[name];
    if (selectedValue) {
      const selectedValueAsArray = isString(selectedValue) ? selectedValue.split(',') : selectedValue;
      selectedValue = selectedValueAsArray.length === 1 ? selectedValue : selectedValueAsArray;
      if (inputSettings?.multiple) {
        selectedValue = flatten([selectedValue]);
      }
    }

    return (
      <InputComponent
        style={{ marginBottom: 0 }}
        type={INPUT_TYPE.SELECT}
        name={filterName}
        placeholder={placeholder || 'Select...'}
        // disabled={filter.disabled}
        inputSettings={{ ...(inputSettings || {}) }}
        label={label}
        inputOptions={optionsWithUnspecifiedValue}
        labelType={LABEL_TYPE.above}
        onChange={(v: unknown) => {
          if (onChange) onChange(v, filterName);
          else {
            defaultOnChange(v);
          }
        }}
        value={selectedValue === undefined ? notSpecifiedValue : selectedValue}
        disabled={disabled}
      />
    );
  }, [optionsWithUnspecifiedValue, onChange, query?.[name], disabled]);

  return (
    <FilterBarContainerStyled className={`${className} gx-form-row0`}>{FilterBarComponent}</FilterBarContainerStyled>
  );
};

export default React.memo(FilterBar);
